import { render, staticRenderFns } from "./StdRiskTxtList.vue?vue&type=template&id=40e9bef0&"
import script from "./StdRiskTxtList.vue?vue&type=script&lang=js&"
export * from "./StdRiskTxtList.vue?vue&type=script&lang=js&"
import style0 from "./StdRiskTxtList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdRiskTxtList.vue"
export default component.exports